import React from "react";
import { Box, Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";

import { useIsMobileApp } from "../../Hooks/useIsMobileApp";
import { useIsDesktopApp } from "../../Hooks/useIsDesktopApp";

interface CampaignFootnoteProps {
  description?: string;
  verifiedBadge?: string | null;
}

const CampaignFootnote: React.FC<CampaignFootnoteProps> = ({
  description,
  verifiedBadge,
}) => {
  const { isMobileApp } = useIsMobileApp();
  const { isDesktop } = useIsDesktopApp();

  if (isMobileApp || isDesktop) return <></>;
  return (
    <FootnoteContainer>
      {verifiedBadge && (
        <Box>
          <StyledSvg src={verifiedBadge} paddingTop="5px" marginRight="12px" />
        </Box>
      )}
      <Text color="chalk" variant="text.labelXSmall" fontWeight={1}>
        {description}
      </Text>
    </FootnoteContainer>
  );
};

export { CampaignFootnote };

const StyledSvg = styled(Image)`
  width: 20px;
  margin-right: 5px;
  align-self: end;
`;

const FootnoteContainer = styled(Flex)`
  align-items: center;
  justify-content: start;
  width: 100%;
  border-radius: 20px;
  padding: 20px;
`;
